import { InferType } from "yup";
import { instanceSchema } from "./schemas";

export enum InstanceType {
  FOLDER = "folder",
  RECORD = "record",
}

export type ActiveInstance = {
  id: string;
  type: InstanceType;
};

export type validInstance = InferType<typeof instanceSchema>;
